import { default as AkBanner, type BannerProps as AkBannerProps } from '@atlaskit/banner';

import { wrapComponentForChoreographer } from '../utils';

export const Banner = wrapComponentForChoreographer<AkBannerProps>(AkBanner);
